export default "__VITE_ASSET__P6Fats9U__"